import React from "react";
import { Container, Heading, SubHeading,ImageSwiper,Line} from "./styles/slider";

export default function Slider({ children, ...restProps }) {
  return <Container {...restProps}> {children} </Container>;
}

Slider.Heading = function SliderHeading({ children, ...restProps }) {
  return <Heading {...restProps}>{children}</Heading>;
};

Slider.SubHeading = function SliderSubHeading({ children, ...restProps }) {
  return <SubHeading {...restProps}>{children}</SubHeading>;
};

Slider.ImageSwiper = function SliderImageSwiper({children, ...restProps}){
  return <ImageSwiper {...restProps}>{children}</ImageSwiper>;
}

Slider.Line = function SliderLine({children, ...restProps}){
  return <Line {...restProps}>{children}</Line>
}